import React, { ChangeEvent, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";

export interface DefaultsChangedEvent {
  values: {
    PINBlock: string;
    DUKPT: boolean;
    Name: string;
  };
}

interface Props {
  defaultName: string;
  onChange?: (event: {
    values: { DUKPT: boolean; PINBlock: string; Name: string };
  }) => void;
}

const CardDefaultFields = ({ onChange, defaultName }: Props) => {
  const [name, setName] = useState(defaultName);
  const [PINBlock, setPINBlock] = useState("Format 0");
  const [DUKPT, setDUKPT] = useState(true);

  return (
    <Box my={1}>
      <h4>Default values</h4>
      <Box ml={3} mb={1} width={240}>
        <TextField
          label="Card table name"
          value={name}
          fullWidth
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setName(event.target.value);
            if (onChange instanceof Function) {
              onChange({
                values: {
                  DUKPT: DUKPT,
                  PINBlock: PINBlock,
                  Name: event.target.value,
                },
              });
            }
          }}
        />
      </Box>
      <Box ml={3} mb={1} width={240}>
        <TextField
          label="PINBlock"
          value={PINBlock}
          fullWidth
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setPINBlock(event.target.value);
            if (onChange instanceof Function) {
              onChange({
                values: {
                  DUKPT: DUKPT,
                  PINBlock: event.target.value,
                  Name: name,
                },
              });
            }
          }}
        />
      </Box>
      <Box ml={3}>
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={DUKPT}
                onChange={(
                  event: React.ChangeEvent<HTMLInputElement>,
                  checked
                ): void => {
                  setDUKPT(checked);
                }}
              />
            }
            label="DUKPT"
          />
        </FormControl>
      </Box>
    </Box>
  );
};

export default CardDefaultFields;
